import React from 'react';
import styles from '../assets/styles/HeroSection.module.css';
import imgBothFronton from '../assets/images/both_fronton.jpg';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <div>
      <div className={styles.hero}>
        <div className={styles.imgContainer}>
          <img className={styles.img} src={imgBothFronton} alt="hero" />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.text}>
            <div className={styles.textTitle}>Lawyers You Can Trust.</div>
            <div className={styles.textDescription}>At Starnet Legal, we are deeply committed to the well-being of our community, understanding that strong legal representation is essential to its growth and success. We take pride in building lasting relationships with the individuals, families, and businesses we serve, ensuring they have the guidance and support needed to navigate life’s legal challenges. Our firm is more than a place of advocacy—it is a trusted partner dedicated to protecting the rights, interests, and future of the community we call home.</div>
          </div>
          <div className={styles.buttonContainer}>
            <Link to="/#contact" className={`${styles.consultButton} ${styles.button}`}>
              Book a Consult
            </Link>
            <Link to="/about" className={`${styles.learnButton} ${styles.button}`}>
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;